<div class="time-box">
  <div class="date">{{ now | async | date:'yyyy年MM月dd日' }}</div>
  <div class="time">{{ now | async | date:'HH:mm:ss' }}</div>
</div>
<div class="radio-box">
  <div>
    <input id="radio0" class="radio-button" name="kind" type="radio" value="0" [(ngModel)]="selectedKind" />
    <label for="radio0" (click)="acceptSound()">出社</label>
  </div>
  <div>
    <input id="radio1" class="radio-button" name="kind" type="radio" value="1"  [(ngModel)]="selectedKind" />
    <label for="radio1" (click)="acceptSound()">退社</label>
  </div>
  <div>
    <input id="radio2" class="radio-button" name="kind" type="radio" value="2"  [(ngModel)]="selectedKind" />
    <label for="radio2" (click)="acceptSound()">外出</label>
  </div>
  <div>
    <input id="radio3" class="radio-button" name="kind" type="radio" value="3"  [(ngModel)]="selectedKind" />
    <label for="radio3" (click)="acceptSound()">戻り</label>
  </div>
</div>
<div class="status-box">
  <p [ngClass]="{'status-text': true, 'success': statusStyle === 'success', 'error': statusStyle === 'error'}">{{statusText}}</p>
</div>
<div class="footer-box">
  <div class="mode-change-button-box">
    <button class="mode-change-button" type="button" (click)="logout()">申請モードに切り替える</button>
  </div>
  <div class="version">
    <p>{{appVersion}}</p>
  </div>
</div>
